import script from "./FavoriteKit.vue?vue&type=script&lang=js"
export * from "./FavoriteKit.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__